module.exports = __webpack_public_path__ + "img/box7-4.c4fe97d5.png";